import { LocaleType } from "./LocaleType";

export const cy: LocaleType = {
    loading: "Llwytho",
    about: "Am y cais",
    tutorial: "Tiwtorial",
    send: "Anfon",
    welcome: "Croeso",
    onboarding: "Cychwyn",
    connected: "Cysylltiedig",
    disconnected: "Dadgysylltiedig",
    strange_noises: "Sŵn rhyfedd",
    you_can_start_anew: "Gallwch ddechrau o'r newydd",

    your_nick: "Eich llysenw...",
    welcome_back: "Croeso yn ôl",
    draw_something_special: "Tynnu llinell!",

    blocked_notice: "Rydych wedi cael eich gwahardd am byth.",
    rejected_notice: "Rwy'n teimlo eich bod yn tynnu rhywbeth amhriodol.",
    accepted_notice: "Rydym wedi adolygu'r ddelwedd ac mae'n iawn, diolch!",

    anonymous_mode_notice: "Nid yw'r cais hwn yn gweithio mewn modd anhysbys.",
    connection_error: "Gwall cysylltu",

    about_you: "Amdanat ti",
    about_you_hint: "Mae'r cais hwn yn anhysbys, ond gallwch ddweud rhywbeth amdanoch chi os ydych chi eisiau. Er enghraifft, beth yw eich hoff liw, neu beth sydd wedi dod â chi yma. Bydd eich gwybodaeth yn ein helpu i ddeall pwy sy'n defnyddio ein cais a sut y gallwn ei wella.",

    select_color: "Dewiswch liw",
    too_short_notice: "Roedd hynny'n rhy fyr - ceisiwch linell hirach!",
    too_small_notice: "Tynwch rywbeth mwy!",
    your_drawing_was_submitted: "Mae eich lluniad wedi'i gyflwyno.",
    wait_to_show_on_facade: "Arhoswch nes i ni ei ddangos ar y fasâd...",

    sending_image_plese_wait: "Rydym yn anfon eich lluniad, aroswch ychydig eiliadau..."
}